export default "__VITE_ASSET__BejSoUdW__"